import CommonImg from "@/components/Common/Img";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRemoveProjectGroupsMembers } from "@/libs/react-query/hooks/useProjectQuery";
import { useNavigate, useParams } from "react-router-dom";
import DeleteIcon from "@/assets/images/delete-pink.svg";
import InviteUserDialog from "./InviteUserDialog";
import { User } from "@/types/user";
import { CurrentUserContent } from "@/types/setting";
import useUserStore from "@/stores/User";

export default function ProjectUsers({ users = [] }: { users: User[] }) {
  const { group_id = "" } = useParams();
  const navigate = useNavigate();

  const storedUser: CurrentUserContent = useUserStore((state) => state.user);

  const { mutate: removeMember } = useRemoveProjectGroupsMembers(group_id);

  const handleRemoveUser = (user_id: string) => {
    removeMember(
      { users: [{ user_id }] },
      {
        onSuccess: () => {
          if (user_id === storedUser.user_id) {
            navigate("/management/projects");
          }
        },
      }
    );
  };

  return (
    <div className="flex flex-col w-full h-[240px] gap-3 ">
      <div className="flex flex-col gap-3 overflow-auto">
        {users.map((user) => (
          <div
            key={`users-${user.user_id}`}
            className="flex items-center gap-2"
          >
            <Avatar className="size-[24px]">
              <AvatarImage src={user.img_url} />
              <AvatarFallback>R</AvatarFallback>
            </Avatar>
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center gap-2 w-full">
                <span className="text-xs text-gray-A font-semibold">
                  {user.user_name}
                </span>
                <span className="text-xs text-gray-C font-semibold">
                  {user.group_name}
                </span>
              </div>

              {users.length > 1 && (
                <button onClick={() => handleRemoveUser(user.user_id)}>
                  <CommonImg src={DeleteIcon} alt="delete" />
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
      <InviteUserDialog users={users} />
    </div>
  );
}
